import { getStrapiPublicOrigin } from '@/lib/strapiOrigins';

const PANEL_STRAPI_PROXY_PREFIX = '/strapi-internal';

export const PANEL_STRAPI_FETCH_TIMEOUT_MS = 120_000;

const getServerStrapiOrigin = (): string => {
  const url = (process.env.STRAPI_SERVER_URL || 'http://strapi:1337').trim().replace(/\/$/, '');
  return url || 'http://strapi:1337';
};

/**
 * Полный URL к Strapi API.
 * SSR — напрямую в контейнер Strapi (без nginx и без лимита web-prod).
 * Браузер — same-origin прокси Next (`/strapi-internal/...`), nginx не участвует.
 */
export const buildStrapiApiUrl = (apiPath: string): string => {
  const segment = apiPath.replace(/^\/api\//, '').replace(/^\//, '');
  if (typeof window === 'undefined') {
    return `${getServerStrapiOrigin()}/api/${segment}`;
  }
  return `${PANEL_STRAPI_PROXY_PREFIX}/${segment}`;
};

/** База для axios: `.../api` на сервере или `/strapi-internal` в браузере. */
export const getPanelStrapiAxiosBase = (): string => {
  if (typeof window === 'undefined') {
    return `${getServerStrapiOrigin()}/api`;
  }
  return PANEL_STRAPI_PROXY_PREFIX;
};

/** Публичный origin только для медиа (uploads), не для JSON API. */
export const resolveStrapiMediaUrl = (path: string): string => {
  const trimmed = path.trim();
  if (!trimmed) {
    return '';
  }
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }
  const origin = getStrapiPublicOrigin();
  return trimmed.startsWith('/') ? `${origin}${trimmed}` : `${origin}/${trimmed}`;
};
